import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import StackTrace from 'stacktrace-js';


@Injectable({
  providedIn: 'root',
})
export class CrashlyticsService {
  async crash() {
    await FirebaseCrashlytics.crash({ message: 'Test crash' });
  }

  async setCustomKey() {
    await FirebaseCrashlytics.setCustomKey({
      key: 'page',
      value: 'home',
      type: 'string',
    });
  }

  async setUserId() {
    await FirebaseCrashlytics.setUserId({
      userId: '123',
    });
  }

  async log() {
    await FirebaseCrashlytics.log({
      message: 'This is a log message',
    });
  }

  async setEnabled() {
    await FirebaseCrashlytics.setEnabled({ enabled: true });
  }

  async isEnabled(): Promise<boolean> {
    const { enabled } = await FirebaseCrashlytics.isEnabled();
    return enabled;
  }

  async didCrashOnPreviousExecution(): Promise<boolean> {
    const { crashed } = await FirebaseCrashlytics.didCrashOnPreviousExecution();
    return crashed;
  }

  async sendUnsentReports() {
    await FirebaseCrashlytics.sendUnsentReports();
  }

  async deleteUnsentReports() {
    await FirebaseCrashlytics.deleteUnsentReports();
  }

  async recordException() {
    await FirebaseCrashlytics.recordException({
      message: 'This is a non-fatal message.',
    });
  }

  async recordExceptionWithStacktrace(error: Error) {
    const stacktrace = await StackTrace.fromError(error);
    await FirebaseCrashlytics.recordException({
      message: 'Non-fatal error with stacktrace',
      stacktrace,
    });
  }
}
